import React from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import { Conversation } from '@uplift/api';
import { useHistory } from 'react-router-dom';
import { adminUserProfile, careTeamProviderRoute, providerPatientRoute } from '@uplift/constants';
import { useMessagingContext } from '../MessagingProvider.component';
import { useCurrentuser } from '@uplift/contexts';
import { UserRole } from '@uplift/types';
import { useUserMatchesQuery } from '@uplift/queries';
import { Color } from '../types';
import { ConversationItemSubtitle } from '../components/ConversationItemSubtitle';


export const Header: React.FC<{
  color: Color;
  conversation: Conversation;
}> = ({ color, conversation }) => {
  const history = useHistory();
  const me = useCurrentuser();
  const messaging = useMessagingContext();
  const { data: matches } = useUserMatchesQuery(me.id, [ 'active' ]);

  const profileLink = React.useMemo(() => {
    if (me.role === UserRole.superadmin) {
      return adminUserProfile.createLink({ userId: conversation.participantId });
    }
    if (me.role === UserRole.provider) {
      if (conversation.participantRole === UserRole.patient) {
        return providerPatientRoute.createLink({ patientId: conversation.participantId });
      }
    }
    if (me.role === UserRole.patient) {
      const isMatched = matches?.activeMatches.some(m => m.match.providerId === conversation.participantId);

      if (isMatched) {
        return careTeamProviderRoute.createLink({ id: conversation.participantId });
      }
    }
    return null;
  }, [ conversation, me, matches ]);

  const listItemContent = (
    <>
      <ListItemAvatar>
        <Avatar>{conversation.name[0]}</Avatar>
      </ListItemAvatar>
      <ListItemText
        primary={conversation.name}
        secondary={<ConversationItemSubtitle color={color} conversation={conversation} />}
      />
    </>
  );

  if (profileLink) {
    return (
      <ListItemButton
        title="Open profile"
        alignItems="flex-start"
        onClick={() => {
          if (profileLink) {
            history.push(profileLink);
            messaging.closeModal();
          }
        }}
      >
        {listItemContent}
      </ListItemButton>
    );
  }

  return (
    <ListItem alignItems="flex-start">
      {listItemContent}
    </ListItem>
  );
};
